import React, { Component } from "react";
import { PiCaretRightLight } from "react-icons/pi";
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import Ad from "../../assets/ad.png";
import Sso from "../../assets/sso.png";
import Azure from "../../assets/azure.png";
import Taconnect from "../../assets/threatcop-back.png";

import "./integration.css";
import { getCookie } from "../../function";
import swalAlert from "../../swalFunction";
import NewConnectTAModal from "../../component/connect-ta-modal/new-connect-ta-modal";

export default class Integration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }
        this.isTASyncing = getCookie('isTASyncing'); //use api for this
        this.isNewClient = getCookie('isNewClient');
        this.isTAconnected = getCookie('isTAconnected');
        this.tacEnabled = getCookie('tacEnabled');
    }
    // Connect Modal
    handleShow = () => {
        this.setState({ showModal: true });
    };

    handleClose = () => {
        this.setState({ showModal: false });
    };
    handleModal = (status) => {
        this.setState({ showModal: status });
    };

    render() {
        const { showModal } = this.state;
        return (
            <div className="content-wrap">
                 <div className="breadcrumbbar">
                        <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                            <h4 className="page-title">Integrations</h4>
                            </div>
                        </div>
                        {/* <div className="col-md-8 flexFilterButtons"> </div> */}
                    </div>
                 </div>

                <div className="contentbar">
                    <div className="row">
                        {!this.isTAconnected?(
                            <>
                                <div className="col-sm-4">
                                    <div className="wrapIntegration">
                                        <div className="headerIntegration">
                                            <img src={Ad} className="img-fluid" />
                                        </div>
                                        <div className="bodyIntegration">
                                        <h5>AD Integration</h5>   
                                        <p>Credentials for Active Directory integration, 
                                            used for user authentication and directory services.</p> 
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    this.isTASyncing? (
                                                        <Tooltip id="top">Threatcop Admin Sync is already in progress</Tooltip>
                                                    ) : (
                                                        <Tooltip id="top" className="d-none" />
                                                    )
                                                }
											>
                                                <Button className={`btn-primary ${this.isTASyncing && 'disabledCls2'}`} onClick={() => {if(!this.isTASyncing) return this.props.history.push("/ad")}}>Integrate <PiCaretRightLight className="btn-icon"></PiCaretRightLight></Button>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-4">
                                    <div className="wrapIntegration">
                                        <div className="headerIntegration">
                                            <img src={Azure} className="img-fluid" />
                                        </div>
                                        <div className="bodyIntegration">
                                            <h5>Microsoft Azure</h5>   
                                            <p>Settings and integrations with Microsoft Azure services for cloud computing and storage.</p>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    this.isTASyncing? (
                                                        <Tooltip id="top">Threatcop Admin Sync is already in progress</Tooltip>
                                                    ) : (
                                                        <Tooltip id="top" className="d-none" />
                                                    )
                                                }
											>
                                                <Button className={`btn-primary ${this.isTASyncing && 'disabledCls2'}`} onClick={() => {if(!this.isTASyncing) return this.props.history.push("/azure")}}>Integrate <PiCaretRightLight className="btn-icon"></PiCaretRightLight></Button>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="col-sm-4">
                                    <div className="wrapIntegration">
                                        <div className="headerIntegration">
                                            <img src={Gsuite} className="img-fluid" />
                                        </div>
                                        <div className="bodyIntegration">
                                            <h5>Google Workspace</h5>   
                                            <p>Configuration and integration with Google Workspace 
                                                (formerly G-Suite) for business applications and email.</p> 
                                                <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    this.isTASyncing? (
                                                        <Tooltip id="top">Threatcop Admin Sync is already in progress</Tooltip>
                                                    ) : (
                                                        <Tooltip id="top" className="d-none" />
                                                    )
                                                }
                                                >
                                                    <Button className={`btn-primary ${this.isTASyncing && 'disabledCls2'}`} onClick={() => {if(!this.isTASyncing) return this.props.history.push("/g-suite")}}>Integrate <PiCaretRightLight className="btn-icon"></PiCaretRightLight></Button>
                                                </OverlayTrigger> 
                                        </div>
                                    </div>
                                </div> */}

                                <div className="col-sm-4">
                                    <div className="wrapIntegration">
                                        <div className="headerIntegration">
                                            <img src={Sso} className="img-fluid" />
                                        </div>
                                        <div className="bodyIntegration">
                                            <h5>Single Sign-On Integration</h5>   
                                            <p>Single Sign-On configuration to allow users to access multiple applications with one set of login credentials.</p> 
                                            <OverlayTrigger
											placement="top"
											overlay={
												this.isTASyncing? (
													<Tooltip id="top">Threatcop Admin Sync is already in progress</Tooltip>
												) : (
													<Tooltip id="top" className="d-none" />
												)
											}
											>
                                                <Button className={`btn-primary ${this.isTASyncing && 'disabledCls2'}`} onClick={() => {if(!this.isTASyncing) return this.props.history.push("/sso")}}>Integrate <PiCaretRightLight className="btn-icon"></PiCaretRightLight></Button>
                                            </OverlayTrigger> 
                                        </div>
                                    </div>
                                </div>
                            </>
                        ):("")}

                        {!this.isNewClient && this.tacEnabled && (
                            // (!this.isTAconnected)?(
                            //     <div className="col-sm-4">
                            //         <div className="wrapIntegration">
                            //             <div className="headerIntegration">
                            //                 <img src={Taconnect} className="img-fluid"/>
                            //             </div>
                            //             <div className="bodyIntegration">
                            //                 <h5>Theatcop Admin</h5>   
                            //                 <p>Easily manage your connection between Threatcop Admin and your current product.</p>  
                            //                 <OverlayTrigger
                            //                     placement="top"
                            //                     overlay={
                            //                         this.isTASyncing? (
                            //                             <Tooltip id="top">Threatcop Admin Sync is already in progress</Tooltip>
                            //                         ) : (
                            //                             <Tooltip id="top" className="d-none" />
                            //                         )
                            //                     }
                            //                     >
                            //                         <Button className={`btn-primary ${this.isTASyncing?"disabledCls2":""}`} onClick={!this.isTASyncing ? this.handleShow : undefined}>Integrate <PiCaretRightLight className="btn-icon"></PiCaretRightLight></Button>
                            //                 </OverlayTrigger>
                                                
                            //             </div>
                            //         </div>
                            //     </div>
                            // ):(
                            //     <div className="col-sm-12">
                            //         <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                            //         Easily manage your connection between Threatcop Admin and your current
                            //         product.
                            //         </p>
                            //         <Button
                            //         variant="danger"
                            //         className="d-flex align-items-center gap-2"
                            //         onClick={() => swalAlert("Disconnect TSAT", "To disconnect TSAT from Threatcop Admin, navigate to the Application Management section in Threatcop Admin.", "warning")}
                            //         >
                            //         <span>🔗</span>
                            //         <span>Disconnect Threatcop Admin</span>
                            //         </Button>
                            //         <div className="mt-4">
                            //             <h5 className="fw-bold" style={{ fontSize: "1rem" }}>Disclaimer</h5>
                            //             <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                            //                 By disconnecting, you will terminate the integration between Threatcop
                            //                 Admin and your current product. Please ensure this action is
                            //                 intended, as it may affect ongoing processes.
                            //             </p>
                            //         </div>

                            //     </div>
                            // )
                            <div className="col-sm-4">
                                <div className="wrapIntegration">
                                    <div className="headerIntegration">
                                        <img src={Taconnect} className="img-fluid"/>
                                    </div>
                                    <div className="bodyIntegration">
                                        <h5>Theatcop Admin</h5>   
                                        <p>Easily manage your connection between Threatcop Admin and your current product.</p>  
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                this.isTASyncing? (
                                                    <Tooltip id="top">Threatcop Admin Sync is already in progress</Tooltip>
                                                ) : (
                                                    <Tooltip id="top" className="d-none" />
                                                )
                                            }
                                            >
                                                <Button className={`${!this.isTAconnected?"btn-primary":""} ${this.isTASyncing?"disabledCls2":""}`} variant={this.isTAconnected?"danger":""} onClick={!this.isTASyncing ? (
                                                    (!this.isTAconnected)?this.handleShow:(() => swalAlert("Disconnect TSAT", "To disconnect TSAT from Threatcop Admin, navigate to the Application Management section in Threatcop Admin.", "warning")) 
                                                ): undefined}>{!this.isTAconnected?"Integrate":"Disconnect"} <PiCaretRightLight className="btn-icon"></PiCaretRightLight></Button>
                                        </OverlayTrigger>
                                            
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>     
                <NewConnectTAModal show={showModal} handleClose={this.handleClose} handleModal={this.handleModal}/>            
         </div>
        );
    }
}